// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"585933a6","703":"b867a23a","787":"e49df0f8"}[chunkId] + ".chunk.js";
};